angular.module('gym.waivers').controller('WaiverReviewCtrl', ["$scope", "$document", "$rootScope", "$stateParams", "$state", "$modal", "$http", "$window", "$filter", "$timeout", "flash", "loadingAnimation", "WaiverReviews", "EmploymentService", "Restangular", "waiver", "membershipPlans", function($scope, $document, $rootScope, $stateParams, $state, $modal, $http, $window, $filter, $timeout, flash, loadingAnimation, WaiverReviews, EmploymentService, Restangular, waiver, membershipPlans) {
  var amountChangedAndConsentRequired, amountValid, applyEdiatbleMembershipDetails, generateMembershipData, getMembershipOptionsPurchaseLimitExceeded, gym, hasSelectedMembership, isBackdatedPaymentCheckRequired, isConsentRequired, loadDefaultDates, openConsentModal, openMembershipPaymentBackdatedModal, openPurchaseLimitExceededModal, parseAmount, parseMonetaryValue, parsedChanges, primaryContact, resetMemberships, save;
  gym = $rootScope.gym;
  $scope.currency = gym.currency_symbol;
  $scope.waiver = waiver.plain();
  $scope.waiver.skip_purchase_limit_validation = false;
  $scope.permissions = EmploymentService.get().permissions;
  Restangular.one('gyms', gym.id).all('email_overrides').getList({
    count: 100
  }).then(function(data) {
    var override;
    override = _.find(data, function(item) {
      return item.email_type === 'waiver_consent_request';
    });
    return $scope.consentRequestEmail = (function() {
      switch (false) {
        case !(override != null ? override.do_not_send : void 0):
          return void 0;
        case !(override != null ? override.email_override : void 0):
          return override != null ? override.email_override : void 0;
        default:
          return gym.payor_email;
      }
    })();
  });
  $scope.isStale = function() {
    var waiverDate;
    waiverDate = moment($scope.waiver.signed_waiver_attributes.created_at);
    return moment().add(30, 'days').isBefore(waiverDate, 'days');
  };
  $scope.walletDetails = waiver.signed_waiver_attributes.signed_waiver_wallet_detail_attributes;
  $scope.waiverForm = waiver.signed_waiver_attributes.signed_waiver_form_attributes;
  $scope.contact = waiver.signed_waiver_attributes.signed_waiver_contacts_attributes[0];
  $scope.hasDependants = $scope.waiver.signed_waiver_attributes.signed_waiver_contacts_attributes.length > 1;
  $scope.isOnlyParentPaysMembership = $scope.waiverForm.family_membership_strategy === 'only_parent_pays_membership';
  $scope.isEachSigneeChoosesMembership = $scope.waiverForm.family_membership_strategy === 'each_signee_chooses_own_membership';
  $scope.primaryContact = primaryContact = waiver.signed_waiver_attributes.signed_waiver_contacts_attributes.find(function(c) {
    return c.primary;
  });
  generateMembershipData = function() {
    $scope.membershipPlans = membershipPlans.plain();
    return $scope.waiver.signed_waiver_review_contacts_attributes = $scope.waiver.signed_waiver_attributes.signed_waiver_contacts_attributes.map(function(contact) {
      var item;
      item = $scope.waiver.signed_waiver_review_contacts_attributes.find(function(i) {
        return i.signed_waiver_contact_id === contact.id;
      }) || {};
      item.signed_waiver_contact_id = contact.id;
      return item;
    });
  };
  $scope.resetMembership = function(membershipData) {
    membershipData.membership_recurring_payments_start_on = membershipData.old_membership_recurring_payments_start_on;
    membershipData.membership_upfront_payment_on = membershipData.old_membership_upfront_payment_on;
    membershipData.membership_start_date = membershipData.old_membership_start_date;
    membershipData.membership_cost_upfront = membershipData.old_membership_cost_upfront;
    membershipData.membership_cost_repeat = membershipData.old_membership_cost_repeat;
    membershipData.membership_plan_id = membershipData.old_membership_plan_id;
    membershipData.membership_label = membershipData.old_membership_label;
    return membershipData.membership_plan_archived = membershipData.old_membership_plan_archived;
  };
  resetMemberships = function() {
    return $scope.waiver.signed_waiver_review_contacts_attributes.forEach($scope.resetMembership);
  };
  if ($scope.waiverForm.membership_options_active) {
    generateMembershipData();
  }
  $scope.isEditableMembershipFree = function() {
    var plan;
    if (!$scope.editableMembership) {
      return false;
    }
    plan = $scope.membershipPlan($scope.editableMembership.membership_plan_id);
    if (!plan) {
      return false;
    }
    return !(plan.cost_upfront > 0 || plan.cost_repeat > 0);
  };
  $scope.isEditableMembershipRecurring = function() {
    var plan;
    if (!$scope.editableMembership) {
      return false;
    }
    plan = $scope.membershipPlan($scope.editableMembership.membership_plan_id);
    if (!plan) {
      return false;
    }
    return plan.plan_type === 'recurring';
  };
  $scope.displayMemberNumber = function(contact) {
    var signed_waiver;
    signed_waiver = $scope.waiver.signed_waiver_attributes;
    return signed_waiver.signed_waiver_form_attributes.accept_member_number && contact.attending;
  };
  $scope.onStartDateChange = function() {
    var plan;
    if ($scope.paymentDateChanged) {
      return;
    }
    plan = $scope.membershipPlan($scope.editableMembership.membership_plan_id);
    return loadDefaultDates(plan, $scope.editableMembership, $scope.editableMembership.membership_start_date);
  };
  $scope.onPaymentDateChange = function() {
    $scope.paymentDateChanged = true;
    return $scope.waiver.errors['membership_upfront_payment_on'] = $scope.membershipChangesInvalid() ? ['Must be earlier than the recurring payment start date'] : void 0;
  };
  loadDefaultDates = function(plan, membership, purchaseDate) {
    var params;
    if (!plan.uuid) {
      return;
    }
    params = {
      gid: gym.id,
      purchase_date: purchaseDate || membership.specified_start_date
    };
    return $http.get(`/membership_defaults/${plan.uuid}`, {
      params: params
    }).then(function(response) {
      membership.membership_start_date = response.data.start_date;
      membership.membership_upfront_payment_on = response.data.upfront_payment_on;
      return membership.membership_recurring_payments_start_on = response.data.recurring_payments_start_on;
    });
  };
  $scope.isFieldAvailable = function(field) {
    return $scope.waiver.signed_waiver_attributes.signed_waiver_form_attributes.required_fields[field] !== 'hidden';
  };
  $scope.selectMembership = function(plan) {
    $scope.waiver.errors = {};
    if (!plan) {
      $scope.editableMembership.membership_plan_id = null;
      $scope.editableMembership.membership_cost_upfront = void 0;
      $scope.editableMembership.membership_cost_repeat = void 0;
      $scope.editableMembership.membership_label = void 0;
      $scope.editableMembership.membership_start_date = void 0;
      $scope.editableMembership.membership_upfront_payment_on = void 0;
      $scope.editableMembership.membership_recurring_payments_start_on = void 0;
      return;
    }
    $scope.editableMembership.membership_cost_upfront = plan.cost_upfront;
    $scope.editableMembership.membership_cost_repeat = plan.cost_repeat;
    $scope.editableMembership.membership_plan_id = plan.id;
    $scope.editableMembership.membership_label = plan.label;
    $scope.editableMembership.membership_plan_archived = void 0;
    return loadDefaultDates(plan, $scope.editableMembership);
  };
  $scope.membershipPlan = function(id) {
    return $scope.membershipPlans.find(function(item) {
      return item.id === id;
    });
  };
  $scope.changeMembership = function(contact) {
    $scope.editableMembership = $scope.membershipSettings(contact.id);
    $scope.editableMembership.first_name = contact.first_name;
    $scope.editableMembership.last_name = contact.last_name;
    if ($scope.editableMembership.membership_plan_archived) {
      return $scope.editableMembership.old_membership_plan_archived = true;
    }
  };
  $scope.membershipSettings = function(contactId) {
    var match, selectedPlan;
    match = $scope.waiver.signed_waiver_review_contacts_attributes.find(function(item) {
      return item.signed_waiver_contact_id === contactId;
    });
    if (!match) {
      return {};
    }
    selectedPlan = $scope.membershipPlans.find(function(item) {
      return item.id === match.membership_plan_id;
    });
    if (match.membership_cost_upfront && !match.membership_upfront_payment_on) {
      if ((selectedPlan != null ? selectedPlan.default_upfront_date_strategy : void 0) === "charge_upfront_amount_on_start_date") {
        match.membership_upfront_payment_on = match.membership_start_date;
      }
    }
    if (match.membership_cost_repeat && !match.membership_recurring_payments_start_on) {
      if ((selectedPlan != null ? selectedPlan.default_repeat_date_strategy : void 0) === "start_repeat_payments_on_membership_start_date") {
        match.membership_recurring_payments_start_on = match.membership_start_date;
      }
    }
    return match;
  };
  $scope.getUpfrontPayment = function(contactId) {
    var date, membershipData, value;
    membershipData = $scope.membershipSettings(contactId);
    if (!membershipData.membership_cost_upfront || !+membershipData.membership_cost_upfront) {
      return 'None';
    }
    value = $filter('currency')(membershipData.membership_cost_upfront, $scope.currency);
    date = $filter('date')(membershipData.membership_upfront_payment_on);
    return `${value} due on ${date}`;
  };
  $scope.getMembershipPurchaseLimitLabel = function(id) {
    var pendingWaiverPurchaseCount, plan;
    plan = $scope.membershipPlan(id);
    if (!(plan != null ? plan.purchase_limit : void 0) && !(plan != null ? plan.purchases_remaining_excluding_pending_waivers : void 0)) {
      return '';
    }
    if (!plan.purchases_remaining_excluding_pending_waivers && plan.purchase_limit) {
      return `${plan.purchase_limit} (Sold out)`;
    } else if (plan.purchases_remaining_excluding_pending_waivers === (plan.purchases_remaining + 1)) {
      pendingWaiverPurchaseCount = plan.purchases_remaining_excluding_pending_waivers - plan.purchases_remaining;
      return `${plan.purchase_limit} (${plan.purchases_remaining_excluding_pending_waivers} remaining, incl. ${$filter('pluralize')('reserved allocation', pendingWaiverPurchaseCount, true)} for this waiver)`;
    } else if (plan.purchases_remaining_excluding_pending_waivers > plan.purchases_remaining) {
      pendingWaiverPurchaseCount = plan.purchases_remaining_excluding_pending_waivers - plan.purchases_remaining;
      return `${plan.purchase_limit} (${plan.purchases_remaining_excluding_pending_waivers} remaining, incl. ${$filter('pluralize')('reserved allocation', pendingWaiverPurchaseCount, true)} across all waivers currently pending review)`;
    } else {
      return `${plan.purchase_limit} (${plan.purchases_remaining_excluding_pending_waivers} remaining)`;
    }
  };
  $scope.getRecurringPayment = function(contactId) {
    var date, membershipData, value;
    membershipData = $scope.membershipSettings(contactId);
    if (!membershipData.membership_cost_repeat || !+membershipData.membership_cost_repeat) {
      return 'None';
    }
    value = $filter('currency')(membershipData.membership_cost_repeat, $scope.currency);
    date = $filter('date')(membershipData.membership_recurring_payments_start_on);
    return `${value} starting on ${date}`;
  };
  applyEdiatbleMembershipDetails = function(item) {
    item.membership_start_date = $scope.editableMembership.membership_start_date;
    item.membership_plan_id = $scope.editableMembership.membership_plan_id;
    item.membership_label = $scope.editableMembership.membership_label;
    item.membership_plan_archived = void 0;
    if ($scope.editableMembership.old_membership_plan_id === item.old_membership_plan_id) {
      item.old_membership_plan_archived = $scope.editableMembership.old_membership_plan_archived;
    }
    if ($scope.getContact(item.signed_waiver_contact_id).primary || !$scope.isOnlyParentPaysMembership) {
      item.membership_cost_upfront = $scope.editableMembership.membership_cost_upfront;
      item.membership_cost_repeat = $scope.editableMembership.membership_cost_repeat;
      item.membership_recurring_payments_start_on = $scope.editableMembership.membership_recurring_payments_start_on;
      return item.membership_upfront_payment_on = $scope.editableMembership.membership_upfront_payment_on;
    }
  };
  $scope.updateMembership = function() {
    $scope.waiver.signed_waiver_review_contacts_attributes = $scope.waiver.signed_waiver_review_contacts_attributes.map(function(item) {
      if (item.signed_waiver_contact_id === $scope.editableMembership.signed_waiver_contact_id) {
        applyEdiatbleMembershipDetails(item);
      }
      return item;
    });
    return $scope.editableMembership = void 0;
  };
  $scope.updateAllMemberships = function() {
    $scope.waiver.signed_waiver_review_contacts_attributes = $scope.waiver.signed_waiver_review_contacts_attributes.map(function(item) {
      applyEdiatbleMembershipDetails(item);
      return item;
    });
    return $scope.editableMembership = void 0;
  };
  $scope.membershipChangesInvalid = function() {
    var recurringPaymentsOn, upfrontPaymentOn;
    upfrontPaymentOn = $scope.editableMembership.membership_upfront_payment_on;
    recurringPaymentsOn = $scope.editableMembership.membership_recurring_payments_start_on;
    if ($scope.editableMembership.membership_plan_archived) {
      return true;
    }
    return upfrontPaymentOn && recurringPaymentsOn && moment(upfrontPaymentOn).isSameOrAfter(recurringPaymentsOn);
  };
  save = function(successMessage) {
    loadingAnimation.show();
    $scope.isLoading = true;
    $scope.waiver.rootObjectName = 'signed_waiver_review';
    $scope.waiver.signed_waiver_id = $stateParams.signed_waiver_id;
    if (!$scope.waiver.skip_purchase_limit_validation) {
      delete $scope.waiver.skip_purchase_limit_validation;
    }
    return WaiverReviews.post($scope.waiver).then(function() {
      var status;
      $state.go('gym.waivers.reviews');
      status = $scope.waiver.status === 'accepted' ? 'approved' : 'rejected';
      loadingAnimation.hide();
      return flash.success = successMessage || `Signed waiver ${status}.`;
    }, function(response) {
      var indx;
      $scope.isLoading = false;
      loadingAnimation.hide();
      flash.error = 'Save failed. Please fix the errors below';
      $scope.waiver.errors = response.data.errors;
      indx = _.findIndex(response.data.signed_waiver_review_contacts_attributes, function(item) {
        return !_.isEmpty(item.errors);
      });
      if (indx >= 0) {
        $scope.changeMembership($scope.waiver.signed_waiver_attributes.signed_waiver_contacts_attributes[indx]);
        $scope.waiver.errors = response.data.signed_waiver_review_contacts_attributes[indx].errors;
      }
      return $timeout(function() {
        if (angular.element('#membershipDetails')[0]) {
          return $document.scrollToElementAnimated(angular.element('#membershipDetails'));
        }
      }, 100);
    });
  };
  $scope.hasArchivedMembershipPlan = function() {
    var match;
    match = $scope.waiver.signed_waiver_review_contacts_attributes.find(function(item) {
      return item.membership_plan_archived;
    });
    return !!match;
  };
  $scope.amountValid = amountValid = function(amount) {
    return +amount > 0;
  };
  $scope.isReady = function() {
    return !$scope.isLoading && !$scope.hasArchivedMembershipPlan();
  };
  parseAmount = function(amount) {
    if (amount >= 0) {
      return +amount;
    } else {
      return 0;
    }
  };
  parseMonetaryValue = function(amount) {
    if (amount === void 0 || amount === null) {
      return 0;
    }
    if (typeof amount === 'string') {
      return parseFloat(amount);
    }
    return amount;
  };
  amountChangedAndConsentRequired = function(newAmount, oldAmount) {
    return parseAmount(newAmount) > parseAmount(oldAmount);
  };
  isBackdatedPaymentCheckRequired = function(selectedMemberships) {
    var todayInGymTz;
    todayInGymTz = moment().tz(gym.tz).startOf('day');
    return selectedMemberships.find(function(item) {
      var isRecurringStartDateBeforeToday, isUpfrontDateBeforeToday, recurringAmount, recurringStartDate, upfrontAmount, upfrontDate;
      upfrontAmount = parseMonetaryValue(item.membership_cost_upfront);
      recurringAmount = parseMonetaryValue(item.membership_cost_repeat);
      upfrontDate = item.membership_upfront_payment_on;
      recurringStartDate = item.membership_recurring_payments_start_on;
      isUpfrontDateBeforeToday = upfrontAmount > 0 && (upfrontDate != null) && moment(upfrontDate).isBefore(todayInGymTz);
      isRecurringStartDateBeforeToday = recurringAmount > 0 && (recurringStartDate != null) && moment(recurringStartDate).isBefore(todayInGymTz);
      return isUpfrontDateBeforeToday || isRecurringStartDateBeforeToday;
    });
  };
  isConsentRequired = function() {
    return !!$scope.waiver.signed_waiver_review_contacts_attributes.find(function(item) {
      var planChanged;
      planChanged = item.membership_plan_id !== item.old_membership_plan_id;
      return planChanged || amountChangedAndConsentRequired(item.membership_cost_upfront, item.old_membership_cost_upfront) || amountChangedAndConsentRequired(item.membership_cost_repeat, item.old_membership_cost_repeat) || (item.consent_required_for_date_changes && (item.membership_start_date !== item.old_membership_start_date || item.membership_upfront_payment_on !== item.old_membership_upfront_payment_on || item.membership_recurring_payments_start_on !== item.old_membership_recurring_payments_start_on));
    });
  };
  $scope.isConsentPending = function() {
    var ref;
    return ((ref = $scope.waiver.consent_request_details) != null ? ref.status : void 0) === 'pending';
  };
  $scope.isConsentAccepted = function() {
    var ref;
    return ((ref = $scope.waiver.consent_request_details) != null ? ref.status : void 0) === 'accepted';
  };
  $scope.isConsentRejected = function() {
    var ref;
    return ((ref = $scope.waiver.consent_request_details) != null ? ref.status : void 0) === 'rejected';
  };
  $scope.isConsentRetracted = function() {
    var ref;
    return ((ref = $scope.waiver.consent_request_details) != null ? ref.status : void 0) === 'retracted';
  };
  $scope.scrollToCustomerConsent = function() {
    return $document.scrollToElementAnimated(angular.element('#waitingForCustomerConsent'));
  };
  $scope.getContact = function(id) {
    return _.find(waiver.signed_waiver_attributes.signed_waiver_contacts_attributes, function(c) {
      return +c.id === +id;
    });
  };
  parsedChanges = _.map(waiver.consent_request_details.proposed_changes, function(change, contactId) {
    change.contact = $scope.getContact(contactId);
    return change;
  });
  $scope.proposedChanges = _.filter(parsedChanges, function(change) {
    return change.membership.expires_after[0] !== change.membership.expires_after[1] || change.membership.membership_cost_repeat[0] !== change.membership.membership_cost_repeat[1] || change.membership.membership_cost_upfront[0] !== change.membership.membership_cost_upfront[1] || change.membership.membership_label[0] !== change.membership.membership_label[1] || change.membership.membership_plan_id[0] !== change.membership.membership_plan_id[1] || change.membership.membership_start_date[0] !== change.membership.membership_start_date[1] || change.membership.membership_upfront_payment_on[0] !== change.membership.membership_upfront_payment_on[1] || change.membership.membership_recurring_payments_start_on[0] !== change.membership.membership_recurring_payments_start_on[1];
  });
  $scope.resendEmail = function() {
    var modalInstance;
    modalInstance = $modal.open({
      template: require('templates/gyms/waivers/review/resend_email_modal.html.slim'),
      size: 'lg',
      resolve: {
        waiver: function() {
          return waiver.signed_waiver_attributes;
        },
        waiverReview: function() {
          return WaiverReviews.get('new', {
            signed_waiver_id: waiver.signed_waiver_attributes.id
          });
        },
        gym: function() {
          return gym;
        }
      },
      controller: 'WaiverResendConsentRequestModalCtrl'
    });
    return modalInstance.result.then(function(data) {
      var url;
      url = `/gyms/${gym.id}/waivers/consent_requests/${data.consentRequest.id}/resend_email`;
      return $http.put(url, {
        email_message_from_gym: data.message
      }).then(function() {
        return flash.success = 'Consent request email sent successfully';
      }, function() {
        return flash.error = 'There was an error processing the request.';
      });
    });
  };
  $scope.retractConsentRequest = function() {
    var modalInstance;
    modalInstance = $modal.open({
      template: require('templates/gyms/waivers/review/retract_consent_modal.html.slim'),
      size: 'lg',
      controller: 'WaiverRetractConsentRequestModalCtrl'
    });
    return modalInstance.result.then(function(message) {
      var params, url;
      url = `/gyms/${gym.id}/waivers/consent_requests/${waiver.consent_request_details.id}`;
      params = {
        retract_reason: message
      };
      return $http.delete(url, {
        params: params
      }).then(function() {
        return $window.location.reload();
      }, function() {
        return flash.error = 'There was an error processing the request.';
      });
    });
  };
  getMembershipOptionsPurchaseLimitExceeded = function() {
    var filteredPlans, options, uniquePlans;
    options = $scope.waiver.signed_waiver_review_contacts_attributes;
    filteredPlans = options.map(function(option) {
      var plan;
      plan = $scope.membershipPlan(option.membership_plan_id);
      if (((plan != null ? plan.purchase_limit : void 0) != null) && plan.purchases_remaining_excluding_pending_waivers === 0) {
        return plan;
      }
    }).filter(function(plan) {
      return plan != null;
    });
    uniquePlans = filteredPlans.reduce(function(acc, plan) {
      if (!acc.find(function(p) {
        return p.id === plan.id;
      })) {
        acc.push(plan);
      } else {

      }
      return acc;
    }, []);
    return uniquePlans;
  };
  hasSelectedMembership = function() {
    return $scope.waiver.signed_waiver_review_contacts_attributes.find(function(item) {
      return item.membership_plan_id;
    });
  };
  $scope.approve = function() {
    var allSelectedMembershipPlans, hasMembership, purchaseLimitExceededPlans;
    allSelectedMembershipPlans = [];
    hasMembership = hasSelectedMembership();
    purchaseLimitExceededPlans = getMembershipOptionsPurchaseLimitExceeded();
    if (hasMembership) {
      allSelectedMembershipPlans = generateMembershipData();
    }
    if ($scope.waiverForm.membership_options_active && !hasMembership) {
      flash.error = 'Please select at least one membership before continuing';
      return;
    }
    if ($scope.editableMembership) {
      flash.error = 'Please confirm membership options before continuing.';
      return;
    }
    if ($scope.waiverForm.membership_options_active && purchaseLimitExceededPlans.length > 0) {
      openPurchaseLimitExceededModal(purchaseLimitExceededPlans);
      return;
    }
    if (!isConsentRequired()) {
      if ($scope.gym.has_payment_provider && isBackdatedPaymentCheckRequired(allSelectedMembershipPlans)) {
        openMembershipPaymentBackdatedModal();
        return;
      }
      $scope.waiver.status = 'accepted';
      save();
      return;
    }
    if (isConsentRequired()) {
      openConsentModal();
    }
  };
  openConsentModal = function() {
    var modalInstance;
    modalInstance = $modal.open({
      template: require('templates/gyms/waivers/review/customer_consent_required_modal.html.slim'),
      size: 'lg',
      resolve: {
        waiver: function() {
          return $scope.waiver;
        },
        gym: function() {
          return gym;
        },
        primaryContact: function() {
          return primaryContact;
        }
      },
      controller: ["$scope", "$modalInstance", "waiver", "gym", "primaryContact", function($scope, $modalInstance, waiver, gym, primaryContact) {
        $scope.gym = gym;
        $scope.primaryContact = primaryContact;
        $scope.consentOptional = $scope.gym.gym_config.waiver_consent_optional;
        $scope.params = {};
        $scope.step = 1;
        $scope.submit = function() {
          $scope.errors = {};
          if (!$scope.params.message) {
            $scope.errors = {
              message: 'This field is required'
            };
            return;
          }
          return $modalInstance.close($scope.params);
        };
        $scope.approve = function() {
          $scope.errors = {};
          if (!$scope.params.skip_consent_reason) {
            $scope.errors = {
              skip_consent_reason: 'This field is required'
            };
            return;
          }
          return $modalInstance.close($scope.params);
        };
        $scope.next = function() {
          var ref;
          $scope.params.message = ((ref = waiver.consent_request_details) != null ? ref.email_message_from_gym : void 0) || waiver.default_email_message_from_gym;
          return $scope.step = 2;
        };
        $scope.consentGiven = function() {
          return $scope.step = 3;
        };
        return $scope.cancel = function() {
          return $modalInstance.dismiss('cancel');
        };
      }]
    });
    if (modalInstance != null) {
      return modalInstance.result.then(function(params) {
        var successMessage;
        $scope.waiver.skip_consent_reason = params.skip_consent_reason;
        $scope.waiver.email_message_from_gym = params.message;
        $scope.waiver.status = 'accepted';
        successMessage = params.message ? `A consent request email has been sent to ${primaryContact.email}.` : void 0;
        return save(successMessage);
      }, function() {
        flash.error = 'Membership changes reverted';
        return resetMemberships();
      });
    }
  };
  openMembershipPaymentBackdatedModal = function() {
    var modalInstance;
    modalInstance = $modal.open({
      template: require('templates/gyms/waivers/review/membership_payment_backdated_modal.html.slim'),
      size: 'md',
      controller: ["$scope", "$modalInstance", function($scope, $modalInstance) {
        $scope.submit = function() {
          return $modalInstance.close();
        };
        return $scope.cancel = function() {
          return $modalInstance.dismiss('cancel');
        };
      }]
    });
    return modalInstance.result.then(function() {
      $scope.waiver.status = 'accepted';
      return save();
    }, function() {
      flash.error = 'Membership changes reverted';
      return resetMemberships();
    });
  };
  openPurchaseLimitExceededModal = function(purchaseLimitExceededPlans) {
    var modalInstance;
    modalInstance = $modal.open({
      template: require('templates/gyms/waivers/review/membership_plan_purchase_limit_exceeded_modal.html.slim'),
      size: 'lg',
      resolve: {
        membershipOptions: function() {
          return purchaseLimitExceededPlans;
        }
      },
      controller: ["$scope", "$modalInstance", "membershipOptions", function($scope, $modalInstance, membershipOptions) {
        $scope.membershipOptions = membershipOptions;
        $scope.submit = function() {
          return $modalInstance.close();
        };
        return $scope.cancel = function() {
          return $modalInstance.dismiss('cancel');
        };
      }]
    });
    return modalInstance.result.then(function() {
      $scope.waiver.skip_purchase_limit_validation = true;
      if (!isConsentRequired()) {
        $scope.waiver.status = 'accepted';
        return save();
      } else {
        return openConsentModal();
      }
    }, function() {
      flash.error = 'Membership changes reverted';
      return resetMemberships();
    });
  };
  return $scope.reject = function() {
    var modalInstance;
    if ($scope.editableMembership) {
      flash.error = 'Please confirm membership options before continuing.';
      return;
    }
    modalInstance = $modal.open({
      template: require('templates/gyms/waivers/review/review_reason_modal.html.slim'),
      resolve: {
        waiver: function() {
          return $scope.waiver;
        }
      },
      controller: ["$scope", "$rootScope", "$modalInstance", "waiver", function($scope, $rootScope, $modalInstance, waiver) {
        var ref, walletDetails;
        gym = $rootScope.gym;
        $scope.isLinkedToContact = waiver.signed_waiver_attributes.linked_to_contact;
        walletDetails = (ref = waiver.signed_waiver_attributes) != null ? ref.signed_waiver_wallet_detail_attributes : void 0;
        $scope.paymentMethodWarningVisible = gym.uses_ezidebit && waiver.signed_waiver_attributes.prefill_contact_id && (walletDetails != null ? walletDetails.payment_method_changed : void 0) && (walletDetails != null ? walletDetails.original_customer_ref : void 0) && (walletDetails != null ? walletDetails.customer_ref : void 0) && (walletDetails != null ? walletDetails.original_customer_ref : void 0) === (walletDetails != null ? walletDetails.customer_ref : void 0);
        $scope.submit = function() {
          return $modalInstance.close($scope.reason);
        };
        return $scope.cancel = function() {
          return $modalInstance.dismiss('cancel');
        };
      }]
    });
    return modalInstance.result.then(function(reason) {
      $scope.waiver.reject_reason = reason;
      $scope.waiver.status = 'rejected';
      return save();
    });
  };
}]);
